import { useQuery } from '@tanstack/react-query';
import Api from 'util/Api';
import API from 'constants/api';
import { Paquer } from 'interfaces/paquer';

// Interfaces adicionales para el tipado completo de la respuesta
interface PaquerSort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

interface PaquerPageable {
  sort: PaquerSort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

interface PaquerData {
  content: Paquer[];
  pageable: PaquerPageable;
  last: boolean;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  sort: PaquerSort;
  first: boolean;
  size: number;
  number: number;
  empty: boolean;
}

interface PaquerResponse {
  data: PaquerData;
  code: number;
  message: string;
}

export const geyById = async (id: string | number | null | undefined) => {
  const response = await Api.apiAxios.get(`${API.paquer.getById}${id}`);
  const routes: Paquer = response.data.data;

  return routes;
};

export const getPaquers = async (): Promise<Paquer[]> => {
  try {
    const params = new URLSearchParams({ size: '10000' });
    const { data } = await Api.apiAxios.get<PaquerResponse>(API.paquer.getAll, {
      params,
    });
    return data.data.content;
  } catch (error) {
    console.error('Error fetching paquers:', error);
    throw error;
  }
};

/**
 * Custom hook for fetching paquers using React Query
 * @returns Query result with paquers data and helper functions
 */
export const usePaquers = () => {
  return useQuery({
    queryKey: ['paquers'],
    queryFn: getPaquers,
    staleTime: 5 * 60 * 1000, // 5 minutos
    refetchOnWindowFocus: false,
  });
};

const PaquerService = { geyById, getPaquers, usePaquers };

export default PaquerService;
